// Utility helpers shared across the app.

export function cn(...parts) {
  return parts.filter(Boolean).join(' ');
}

// Haversine distance in km between two coordinates.
export function distanceKm(a, b) {
  if (!a || !b) return null;
  const R = 6371;
  const dLat = ((b.lat - a.lat) * Math.PI) / 180;
  const dLng = ((b.lng - a.lng) * Math.PI) / 180;
  const lat1 = (a.lat * Math.PI) / 180;
  const lat2 = (b.lat * Math.PI) / 180;
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

// Google Maps directions deep link (no API key required).
export function mapsDirectionsUrl(address) {
  const q = encodeURIComponent(
    `${address.street}, ${address.number} - ${address.neighborhood}, ${address.city}`
  );
  return `https://www.google.com/maps/dir/?api=1&destination=${q}`;
}

// WhatsApp deep link. Strips non-digits and prefixes Brazil country code.
export function whatsappUrl(phone, message) {
  const digits = (phone || '').replace(/\D/g, '');
  const withCountry = digits.startsWith('55') ? digits : `55${digits}`;
  const text = message ? `?text=${encodeURIComponent(message)}` : '';
  return `https://wa.me/${withCountry}${text}`;
}

export function fullAddress(address) {
  return `${address.street}, ${address.number} — ${address.neighborhood}, ${address.city}`;
}
